import React from "react";

const QueryString = () => {
  return <div>Query String</div>;
};

export default QueryString;
